import {IssueInProgressIcon} from '@github-ui/custom-icons/IssueInProgressIcon'
import {IssueTodoIcon} from '@github-ui/custom-icons/IssueTodoIcon'
import {type Icon, IssueClosedIcon, IssueOpenedIcon, SkipIcon} from '@primer/octicons-react'

export type IssueStatusVisual = {icon: Icon; color: 'open' | 'done' | 'muted'}

export type IssueStatusColor = IssueStatusVisual['color']

// Keyed by category rather than status name, so renamed and custom statuses share their category's
// visual. Category keys use underscores (`not_planned`); `category:` search values use hyphens.
export const CATEGORY_VISUALS: ReadonlyMap<string, IssueStatusVisual> = new Map<string, IssueStatusVisual>([
  ['new', {icon: IssueOpenedIcon, color: 'open'}],
  ['backlog', {icon: IssueOpenedIcon, color: 'open'}],
  ['planned', {icon: IssueTodoIcon, color: 'open'}],
  ['started', {icon: IssueInProgressIcon, color: 'open'}],
  ['completed', {icon: IssueClosedIcon, color: 'done'}],
  ['not_planned', {icon: SkipIcon, color: 'muted'}],
  ['duplicate', {icon: SkipIcon, color: 'muted'}],
])

export function categoryStatusVisual(category: string | null | undefined): IssueStatusVisual | undefined {
  if (!category) return undefined
  return CATEGORY_VISUALS.get(category.toLowerCase().replaceAll('-', '_'))
}
